/**
 * Modulo que encapsula los formateadores localizados de fechas.
 */

import intervalToDuration from 'date-fns/intervalToDuration';
import { onBeforeFormat } from './src/onBeforeFormat';

// cache para cada `state.id`
const formatter = {};

/**
 * Devuelve un texto que representa la duration entre la fecha pasada en parametro y ahora
 * @param {Object} state
 * @param {Date} value la fecha
 * @returns {string}
 */
export function ago(state, value) {
  try {
    // calculamos la diferencia entre la fecha `value` y ahora
    const { years = 0, months = 0, days = 0, hours = 0, minutes = 0, seconds = 0 } = intervalToDuration({ start: onBeforeFormat(value), end: new Date() });

    if (!formatter[state.id]) {
      formatter[state.id] = new Intl.RelativeTimeFormat(state.id, { numeric: 'auto' });
    }

    // `format`, valores posibles: "year", "quarter", "month", "week", "day", "hour", "minute", "second".
    if (years) {
      return formatter[state.id].format(-1 * years, 'year');
    }
    if (months) {
      return formatter[state.id].format(-1 * months, 'month');
    }
    if (days) {
      return formatter[state.id].format(-1 * days, 'day');
    }
    if (hours) {
      return formatter[state.id].format(-1 * hours, 'hour');
    }
    if (minutes) {
      return formatter[state.id].format(-1 * minutes, 'minute');
    }
    // por defecto, devolvera "ahora" si es 0
    return formatter[state.id].format(-1 * seconds, 'second');
  } catch (e) {
    console.error(e);
    return '';
  }
}

/**
 * # date-fns.formatDistanceToNow
 * https://date-fns.org/v2.23.0/docs/formatDistanceToNow
 *
 * @odeniel 2021/08/19
 *
 * Existe esta función que devuelve un resultado "mas bonito",
 *
 * El problema es que hay que importar los ficheros de locales de date-fns,
 * Importar los asincronamente no es una opción ya que la función debe ser sincrona.
 * La unica solución que veo de momento es que la aplicación cliente se encargue de importar el fichero.
 * A estudiar mas.
 *
 * @example
 * import formatDistanceToNow from 'date-fns/formatDistanceToNow';
 *
 * // importación de objetos de locale de date-fns
 * // tendriamos que importar todas las locales desde ya y eso no queremos
 * // aunque son objetos pequeños
 * import frLocale from 'date-fns/locale/fr';
 *
 * export function ago(state) {
 *   return localizedDate => {
 *     return formatDistanceToNow(localizedDate, { locale: frLocale, addSuffix: true });
 *   };
 * }
 *
 */
